<template>
    <div>
        <div class="bg-white sticky-top pt-2"
             @click="show = !show"
             style="cursor:pointer">
            <div class="d-flex justify-content-between align-items-center">
                <span :class="{ 'font-weight-bold': show }">{{ result.party}}</span>
                <span class="badge badge-light badge-pill">{{ result.percent }}&nbsp;%</span>
            </div>
            <div style="font-size:75%">{{ parties[result.party] }}</div>
            <div class="progress mt-2" style="height: 1pt;">
                <div class="progress-bar" role="progressbar" :style="{ width: result.percent + '%'}" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
        </div>

        <mat-answers :answer="answer" :weight="weight" :party-answer="partyAnswer" :party-reason="partyReason" v-if="show" @click.stop />
    </div>
</template>

<script>
import MatAnswers from './MatAnswers';

import parties from '../data/parties';

export default {
    name: "MatResult",
    props: ["result", "answer", "weight", "partyAnswer", "partyReason"],
    components: {
        MatAnswers
    },
    data() {
        return {
            parties,
            show: false
        };
    },
}
</script>

<style scoped>

</style>